module.exports = __webpack_public_path__ + "static/img/irole.65acaad.png";


//////////////////
// WEBPACK FOOTER
// ./static/hk/mobile_img/role3/kc/irole.png
// module id = xHe3
// module chunks = 7